export const DOC_API_URL =
  process.env.NODE_ENV === 'production'
    ? '/media/v1/'
    : `${process.env.REACT_APP_SERVER_URL || 'http://localhost:5000'}/media/v1/`;
